import React from 'react';
import { getBengkungVisualInfo, cleanBengkungTitle } from '../../data/bengkungRanks';

interface BengkungCulaBadgeProps {
  bengkung: string;
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  fullWidth?: boolean;
  className?: string;
  minWidth?: string;
}

export const BengkungCulaBadge: React.FC<BengkungCulaBadgeProps> = ({
  bengkung,
  size = 'md',
  showText = true,
  fullWidth = true,
  className = '',
  minWidth,
}) => {
  const visualInfo = getBengkungVisualInfo(bengkung);
  const cleanTitle = cleanBengkungTitle(bengkung);

  const heightClasses = {
    sm: 'h-7 text-xs font-bold pl-3.5 pr-10',
    md: 'h-8 text-xs font-bold pl-4 pr-12',
    lg: 'h-9 text-sm font-bold pl-5 pr-14'
  };

  // Optimize cula stripe widths and gaps so stripes never overlap text even at high cula counts
  const isCompact = size === 'sm' || visualInfo.culaCount >= 4;
  const culaWidthClass = isCompact ? 'w-1.5' : 'w-2';
  const culaGapClass = isCompact ? 'gap-1' : 'gap-1.5';
  const culaRightClass = size === 'sm' ? 'right-2.5' : 'right-4';

  const widthClasses = fullWidth
    ? 'w-full'
    : (minWidth || 'min-w-[190px] sm:min-w-[220px] inline-flex rounded-xl');

  return (
    <div
      className={`font-bold shadow-xs flex items-center justify-between relative overflow-hidden transition-all ${
        widthClasses
      } ${visualInfo.beltBgClass} ${visualInfo.textColorClass} ${heightClasses[size]} ${className}`}
      title={`${cleanTitle} (${visualInfo.rankTitle} - ${visualInfo.culaCount} Cula)`}
    >
      {/* Left side: Bengkung Title */}
      {showText && (
        <span className="tracking-wide font-extrabold z-10 shrink-0 select-none whitespace-nowrap mr-3">
          {cleanTitle}
        </span>
      )}

      {/* Right side: Vertical Full-Height Cula Lines */}
      {visualInfo.culaCount > 0 && (
        <div className={`flex items-center ${culaGapClass} h-full absolute ${culaRightClass} top-0 bottom-0 z-10 pointer-events-none`}>
          {Array.from({ length: visualInfo.culaCount }).map((_, index) => (
            <span
              key={index}
              className={`block ${culaWidthClass} h-full ${visualInfo.culaBgClass}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};
